import { mixpanel } from '@fiverr-private/perseus';

export default {
    trackEvent: (eventName, payload) => {

        mixpanel.track(
            eventName,
            payload
        );
    }
};
